import { StakeForm, StakeFormProps } from "./StakeForm";
import { StakeModeTabs } from "./StakeModeTabs";

export const StakeFormShell = (props: StakeFormProps) => (
  <StakeForm {...props} topContent={<StakeModeTabs />} />
);
